let shareUrls = {
  facebook: "//www.facebook.com/sharer.php?u=",
  twitter: "//twitter.com/intent/tweet?url=",
  pinterest: "//pinterest.com/pin/create/button/?url=",
  pocket: "//getpocket.com/save?url=",
}

export const shareToFacebook = () => {
  let url = encodeURIComponent(
    [
      window.location.protocol,
      "//",
      window.location.host,
      window.location.pathname,
    ].join("")
  )

  window.open(
      shareUrls.facebook + url,
      "Share to Facebook",
      "toolbar=0,location=0,menubar=0,height=400,width=600"
  )
}